import { gql } from '@urql/core';

import { defaultMutationFuction } from '/src/graphql/defaultMutationFuction';

export const initializeMetaAdsConnectionMutation = ({ client }) => ({
  mutationFn: ({ siteId, returnUrl }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation InitializeMetaAdsConnection($siteId: Int!, $returnUrl: String!) {
          initializeMetaAdsConnection(siteId: $siteId, returnUrl: $returnUrl) {
            redirectUrl
          }
        }
      `,
      {
        siteId,
        returnUrl,
      },
    ),
});

export const initializeRedditAdsConnectionMutation = ({ client }) => ({
  mutationFn: ({ siteId, returnUrl }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation InitializeRedditAdsConnection($siteId: Int!, $returnUrl: String!) {
          initializeRedditAdsConnection(siteId: $siteId, returnUrl: $returnUrl) {
            redirectUrl
          }
        }
      `,
      {
        siteId,
        returnUrl,
      },
    ),
});
